module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dd98971c2c185caf86144b6b5234d0fa.svg";